import moment from 'moment';
import { BOOKING } from '../constants';
// import { sendBookingConversion } from '../helpers/analytics';

const initialState = {
  currentBooking: undefined,
  loading: false,
  error: undefined
};

const cabinBooking = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_CABIN_BOOKING':
      // eCommerce conversion tracking:
      if (state.currentBooking && action.booking &&
        state.currentBooking.status === BOOKING.PENDING_STATUS &&
        action.booking.status === BOOKING.OK_STATUS
      ) {
        // sendBookingConversion(action.booking);
      }
      return {
        ...state,
        currentBooking: action.booking,
        error: undefined,
        loading: false
      };
    case 'SET_CABIN_BOOKING_LOADING':
      return {
        ...state,
        loading: action.loading
      };
    case 'SET_CABIN_BOOKING_ERROR':
      return {
        ...state,
        error: { message: action.message },
        loading: false
      };
    case 'ADD_PAYMENT': {
      if (!state.currentBooking) {
        return state;
      }
      if (action.payment.order.id === state.currentBooking.mainOrder.id) {
        const newBooking = {
          ...state.currentBooking,
          mainOrder: {
            ...state.currentBooking.mainOrder,
            payments: [
              ...state.currentBooking.mainOrder.payments.filter(p => p.id !== action.payment.id),
              action.payment
            ]
          }
        };
        newBooking.mainOrder.status = action.payment.order.status;
        if (action.payment.status === 'paid' && state.currentBooking.status === BOOKING.PENDING_STATUS) {
          newBooking.status = BOOKING.OK_STATUS;
          // sendBookingConversion(newBooking);
        }
        return {
          ...state,
          currentBooking: newBooking
        };
      }
      return state;
    }
    case 'UPDATE_CABIN_BOOKING_ACTIVITY':
      return {
        ...state,
        currentBooking: { ...state.currentBooking, lastActivity: moment().toString() }
      };
    case 'SET_CABIN_CREW': {
      return {
        ...state,
        crewMembers: action.crewMembers,
        skipper: action.skipper,
        hostess: action.hostess,
        inviteLink: action.inviteLink
      };
    }
    case 'ADD_CABIN_USER': {
      const newCrewMembers = [...state.crewMembers];
      newCrewMembers.push(action.crewMember);
      return {
        ...state,
        crewMembers: newCrewMembers
      };
    }
    case 'INVITE_CABIN_EMAILS': {
      if (!state.currentBooking) {
        return state;
      }
      const newCurrentBooking = { ...state.currentBooking };
      const newCrewInvites = [...(state.currentBooking.crewInvites || [])];

      action.crewInvites.forEach(invitee => newCrewInvites.push(invitee));
      newCurrentBooking.crewInvites = newCrewInvites;
      return {
        ...state,
        currentBooking: newCurrentBooking
      };
    }
    case 'DELETE_CABIN_MEMBER': {
      const remainingCrewMembers = [...state.crewMembers];
      return {
        ...state,
        crewMembers: remainingCrewMembers.filter(crew => crew.id !== action.memberId)
      };
    }
    default:
      return state;
  }
};

export default cabinBooking;
